/* eslint-disable formatjs/no-literal-string-in-jsx */
import Button from '@atlaskit/button/new';
import Heading from '@atlaskit/heading';
import { Stack } from '@atlaskit/primitives';
import { JiraSideNavMessage } from '@post-office/components--jira-side-nav-message';
import { useMessageInstanceEvent } from '@post-office/message-instance-event-frontend-client';
import { useMessageEvent } from '@post-office/message-lifecycle';

import { createRender } from './types';

const BodyContent = () => {
	// https://developer.atlassian.com/platform/post-office/working-with-post-office/technical-deep-dives/pre-defined-filters/#snooze-check-filter
	const { messageSnoozed } = useMessageEvent(); // DEPRECATED: See note below
	const { messageInstanceClicked } = useMessageInstanceEvent();

	const handleSnooze = () => {
		void messageSnoozed(0.04); // Snooze message for 1 hour
		void messageInstanceClicked({
			messageEventType: 'clicked',
			clickedElement: {
				clickIdentifier: 'testing-snooze',
				clickedElement: 'button',
				buttonType: 'primary',
			},
			action: {
				actionType: 'snooze',
				snoozeDuration: 0.04, // Snooze message for 1 hour
			},
			additionalMetadataFromFrontend: {},
		});
	};

	return (
		<Stack space="space.100">
			<Heading size="xsmall">Some amazing NBA</Heading>
			<Button onClick={handleSnooze}>Test snooze</Button>
		</Stack>
	);
};

// TODO: We'll need to create our own component as we want to customise the meatball actions
export const render = createRender(() => <JiraSideNavMessage bodyContent={<BodyContent />} />);

export default render;
